import { WebPlugin } from '@capacitor/core';
export class DontKillMyAppWeb extends WebPlugin {
    constructor() {
        super();
    }
    async requestAutoStart() {
        return new Promise((resolve) => {
            console.log('Request auto start!');
            resolve({ requested: true });
        });
    }
    async requestKeepAppActive() {
        return new Promise((resolve) => {
            console.log('Request keep app active!');
            resolve({ requested: true });
        });
    }
    async requestRunInBackground() {
        return new Promise((resolve) => {
            console.log('Request run in background!');
            resolve({ requested: true });
        });
    }
    async isIgnoringBatteryOptimizations() {
        return new Promise((resolve) => {
            console.log('Request if is ignoring battery optimizations!');
            resolve({ ignoring: true });
        });
    }
    async openAppInfo() {
        return new Promise((resolve) => {
            console.log('Open app info!');
            resolve({ opened: true });
        });
    }
}
//# sourceMappingURL=web.js.map